import { render } from "./AppleKeyboardControl.vue?vue&type=template&id=53fcbe38"
import script from "./AppleKeyboardControl.vue?vue&type=script&lang=js"
export * from "./AppleKeyboardControl.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AppleKeyboardControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53fcbe38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53fcbe38', __exports__)) {
    api.reload('53fcbe38', __exports__)
  }
  
  module.hot.accept("./AppleKeyboardControl.vue?vue&type=template&id=53fcbe38", () => {
    api.rerender('53fcbe38', render)
  })

}


export default __exports__